module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/276b880da7173e717f5265fa518a3729.gif";